import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-toggle',
  templateUrl: './icc-toggle.component.html',
  styleUrls: ['./icc-toggle.component.less'],
})
export class IccToggleComponent {
  constructor() {}

  @Input() checked: boolean;
  @Input() color = '#ffe26d';
  @Input() idDisabled: boolean = false;

  @Output() toggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  switch() {
    this.checked = !this.checked;
    this.toggle.emit(this.checked);
  }
}
